
const data = [
  {
    title: '平台部署及运营推广概述',
    description: '为企业完成网络货运平台的成功部署，提供分步骤分阶段的运营推广方案，打造高效率、高质量运营维护体系。'
  },
  {
    title: '服务内容',
    description: '网络平台搭建\n' +
      '平台建设方案\n' +
      '平台推广方案\n' +
      '平台运营方案\n' +
      '平台商业模式规划'
  },
  {
    title: '服务特点',
    description: '重点突破、分步实施、突出特色、高效运行。'
  }
];

export default data;


// WEBPACK FOOTER //
// ./src/routes/Service/config/product-spread.js